import { render } from "./CustomEventCalender.vue?vue&type=template&id=19dfac24"
import script from "./CustomEventCalender.vue?vue&type=script&lang=js"
export * from "./CustomEventCalender.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__